import {
  type FEEDBACK_STATUS,
  FeedbackStatusMap,
  type SOURCE_STATUS,
  SourceStatusMap,
} from '@/types/feedbackConst';

import { lowerCaseMatch, undefinedException } from './util';

const getTagHTML = (tagMap: TagMapT, key: string) => {
  const tag = tagMap[key];
  let parent = tag;
  let text = '';
  while (parent.level > 0) {
    text = parent.name + '/' + text;
    if (!parent.parent) break;
    parent = tagMap[parent.parent];
    if (!parent) break;
  }
  text = text.slice(0, text.length - 1);
  const textMap = text.split('/');
  textMap[textMap.length - 1] = textMap[textMap.length - 1];
  const tagHTML = textMap
    .reduce((pv, cv) => {
      return pv + '/' + cv;
    }, '')
    .slice(1);
  return tagHTML;
};
const findMatchTagRecursion = (
  tagMap: TagMapT,
  acc: MatchedTagT[],
  alias: string,
  parentMatched: boolean,
  searchValue: string,
  pathString?: string,
): MatchedTagT[] => {
  let newAcc = [...acc]; // Create a copy of the current accumulator array
  const tag = tagMap[alias];
  const newPathString = pathString
    ? `${pathString} ${tag.name} /`
    : `${tag.name} /`;

  if (parentMatched) {
    newAcc.push({
      tag,
      pathString,
    });
    if (tag.children) {
      tag.children.forEach((childTagAlias) => {
        newAcc = findMatchTagRecursion(
          tagMap,
          newAcc,
          childTagAlias,
          true,
          searchValue,
          newPathString,
        );
      });
    }
  } else {
    if (lowerCaseMatch(tag.name, searchValue)) {
      newAcc.push({
        tag,
        pathString,
      });
      if (tag.children) {
        tag.children.forEach((childTagAlias) => {
          newAcc = findMatchTagRecursion(
            tagMap,
            newAcc,
            childTagAlias,
            true,
            searchValue,
            newPathString,
          );
        });
      }
    } else if (tag.children) {
      tag.children.forEach((childTagAlias) => {
        newAcc = findMatchTagRecursion(
          tagMap,
          newAcc,
          childTagAlias,
          false,
          searchValue,
          newPathString,
        );
      });
    }
  }

  return newAcc; // Return the updated accumulator array
};

const feedbackUtils = {
  getSourceStatusLabel: (source_status?: SOURCE_STATUS): IconValueT => {
    if (undefinedException(source_status)) {
      return SourceStatusMap[source_status!];
    }
    return {
      icon: <></>,
      value: '',
    };
  },
  getFeedbackStatusLabel: (feedback_status?: FEEDBACK_STATUS) => {
    if (undefinedException(feedback_status)) {
      return FeedbackStatusMap[feedback_status!];
    }
    return '';
  },
  getTagHTML,
  findMatchTagRecursion,
};

export default feedbackUtils;
